import { CircularProgress } from "@mui/material";

function LoadingBox() {
  return <CircularProgress sx={{ color: '#F95C3D' }} />;
}

export default LoadingBox;
